// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"168":"skill","242":"project","443":"about","831":"education","910":"other-stuffs"}[chunkId] + "." + {"168":"256ed02f","242":"4b55ba70","443":"ed587394","831":"b6f89e9d","910":"aa891c77"}[chunkId] + ".js";
};